module.exports = __webpack_public_path__ + "static/media/skincare.1c323766.jpg";